var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isNew)?_c('span',{class:[
      'kws-int-variety-teaser__badge',
      'badge-new--darkgreen',
      `badge-new--darkgreen-${_vm.language}`
    ]}):_vm._e(),_c('img',{attrs:{"src":_vm.img.src,"srcset":_vm.img.srcset,"loading":"lazy","sizes":_vm.sizes,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }